import React from 'react';
import { SearchableSelect } from '../search/SearchableSelect';
import { useProvince } from '../../hooks/useProvince';

/**
 * Provincia scelta dall'elenco del Gestionale (osservazioni del cliente del
 * 30/10/2026, #1 e #5). Il valore è la sigla. Le province soppresse e le sigle
 * che il Gestionale non conosce compaiono solo se sono già il valore del campo.
 */
export function ProvinciaSelect({ value, onChange, testid, size, placeholder = 'Seleziona' }: {
  value: string;
  onChange: (sigla: string) => void;
  testid?: string;
  size?: 'default' | 'sm';
  placeholder?: string;
}) {
  const province = useProvince();
  const sigla = (value || '').trim().toUpperCase();
  const options = province
    .filter(p => !p.soppressa || p.sigla === sigla)
    .map(p => ({ value: p.sigla, label: `${p.sigla} – ${p.nome}` }));
  if (sigla && province.length > 0 && !options.some(o => o.value === sigla)) {
    options.unshift({ value: sigla, label: sigla });
  }
  return (
    <SearchableSelect
      value={sigla}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      searchPlaceholder="Sigla o nome…"
      emptyMessage="Nessuna provincia"
      testid={testid}
      size={size}
      allowClear={false}
    />
  );
}
